import React from "react";
import { Link } from "react-router-dom";
import clients from "./images/clients.jpeg";

import AOS from "aos";
import "aos/dist/aos.css";
import Visitorform from "./Visitorform";
AOS.init();

function Home() {
  return (
    <>
      <section className="hero-area">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="block">
                <h1
                  className="wow fadeInUp"
                  data-wow-duration=".5s"
                  data-wow-delay=".3s"
                >
                  MACROZION <br /> TECH SYSTEM PVT. LTD.
                </h1>
                <p
                  className="wow fadeInUp"
                  data-wow-duration=".5s"
                  data-wow-delay=".5s"
                >
                  <b className="macrozion-text">
                    Our mission is to digitally transform brands to perform in a
                    competative landscape.
                  </b>
                  <br></br>
                  <b>
                    Business run better while building the strategies and
                    strategies define your feature.
                  </b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="services" id="payment">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-md-12">
              <div className="title text-left ">
                <h2>About us</h2>
              </div>
            </div>
            <div className=" col-md-6">
              <div className="text-left ">
                <p>
                  Macrozion Techsystem is one of the leading Company which
                  working with multiple domain and have a great experience in
                  domain like SAP, Web Development, Mobile Applications, Digital
                  Marketing and other IT-Solutions. Presently has its presence
                  in SAP S/4HANA Implementations, SAP Support, Conversion &
                  Cloud Based Services. Macrozion is a platform designed to help
                  organizations invent digital products and customer
                  experiences.
                </p>
                <br></br>
                <ul className="text-color text-left">
                  <li>
                    <b> 1. We path to drive growth and invent the future.</b>
                  </li>
                  <li>
                    <b> 2. We have a solutions that transfer your business.</b>
                  </li>
                </ul>
                <br></br>
                <p>
                  Our team of highly motivated and experienced consultants work
                  tirelessly with our customers in providing solutions on time
                  with a high quality with dedicated and in-depth knowledge, we
                  can provide on-demand capacity to help you meet challenges,
                  tight deadlines, and promises to the marketplace. We are
                  providing services to the Customers in wide range of
                  industries including Manufacturing, Pharma, Professional
                  Services, Real-Estate and more.
                </p>
                <br></br>
              </div>
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-5">
              <p>
                <img
                  src="./images/about.jpg"
                  alt="Example1"
                  width="460"
                  height="420"
                ></img>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="why-us" className="why-us">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="title text-center ">
                <h2>WHY US</h2>
              </div>
            </div>
            <div className="col-lg-4 hover" data-aos="fade-up">
              <div className="container">
                <span>01</span>
                <h4>Customer Comes First</h4>
                <div>
                  Macrozion team more focus on attending our customers'
                  requirements and meeting and exceeding their expectations.
                </div>
              </div>
            </div>

            <div
              className="col-lg-4 mt-4 mt-lg-0"
              data-aos="fade-up"
              data-aos-delay="150"
            >
              <div className="container hover ">
                <span>02</span>
                <h4>A Team of Inventors</h4>
                <div>
                  Macrozion is a team of inventors, designers and developers
                  focused on the future add-ons. A deep understanding of client
                  business process.
                </div>
              </div>
            </div>

            <div
              className="col-lg-4 mt-4 mt-lg-0"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div className="container hover">
                <span>03</span>
                <h4>Industry Experts</h4>
                <div>
                  We are closing innovation to execution gap from the industry
                  and our IT-Solutions has earned us wide recognition in the
                  industry.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="clients" className="clients">
        <div className="container" data-aos="zoom-in">
          <div className="col-md-12 title text-center">
            <h2>
              <b className="text-color">Meet Our</b> Famous{" "}
              <b className="text-color">Clients</b>
            </h2>
            <div className="row d-flex align-items-center">
              <img
                className="img-fluid"
                src={clients}
                alt=""
                style={{ margin: "20px" }}
                // height={100}
                // width={130}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="services" id="services">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-12">
              <div className="title text-center">
                <h2>Our Services</h2>
              </div>
            </div>

            <div className="col-lg-4 col-sm-6 mb-4 mb-lg-0">
              <div className="service-block p-4 color-bg text-center">
                <div className="service-icon text-center">
                  <i className="tf-ion-ios-copy-outline"></i>
                </div>
                <h3>Custom ERP</h3>
                <b>
                  Do you know 50% of standard ERP software projects fail for the
                  first time!
                </b>
                <p>
                  At Macrozion tech systems, we design and customize enterprise
                  resource planning (ERP)systems for all types of businesses.
                </p>
                <Link to="/Erp" className="btn btn-secondary">
                  Read More
                </Link>
              </div>
            </div>

            <div className="col-lg-4 col-sm-6 mb-4 mb-lg-0">
              <div className="service-block p-4 text-center">
                <div className="service-icon text-center">
                  <i className="tf-ion-ios-alarm-outline"></i>
                </div>
                <h3>SAP</h3>
                <b>
                  Do you know 77% of world's transaction revenue occues through
                  SAP!
                </b>
                <p>
                  SAP implementation enables the creation of an efficient work
                  environment by integrating various work processes.
                </p>
                <Link to="/Sap" className="btn btn-secondary">
                  Read More
                </Link>
              </div>
            </div>

            <div className="col-lg-4 col-sm-6 mb-4 mb-lg-0">
              <div className="service-block p-4 color-bg text-center">
                <div className="service-icon text-center">
                  <i className="tf-ion-ios-book-outline"></i>
                </div>
                <h3>IT Support services</h3>
                <p>
                  <b>
                    THE COST OF CYBERSECURITY CRIMES WILL BE 6 TRILLION DOLLARS
                    BY THE END OF 2021.
                  </b>
                </p>

                <p>
                  Macrozion Techsystem offers a broad range of IT infrastructure
                  support services to assure the high stability and performance
                  of your applications in cloud
                </p>
                <Link to="/Itsupport" className="btn btn-secondary">
                  Read More
                </Link>
              </div>
            </div>
            <div className="text-center">
              <Link to="/Services" className=" btn btn-secondary">
                See More Services
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section id="call" className="call_to_action">
        <div className="container" data-aos="zoom-in">
          <div className="text-center">
            <h3>Call To Action</h3>
            <p>
              Would you like to start a project with us? just press the Call To
              Action option to get in touch with us. Our sales team will guide
              you for your interrogations. Our focus on attending our
              'customers' requirements and meeting and exceeding their
              expectations.
            </p>

            <a href="tel:+9665433121" className="btn btn-warning">
              Call: 9665433121
            </a>
          </div>
        </div>
      </section>
      <section id="map" className="services">
        <div className="row">
          <div className="col-md-1"></div>
          <div className="col-md-5" id="iframe">
            <iframe
              title="/"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.3618744065498!2d73.7527011148933!3d18.557717187387397!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf1a60111fed%3A0x1e033293b6224669!2sMacrozion%20Techsystem%20Private%20Limited!5e0!3m2!1sen!2sin!4v1633078159489!5m2!1sen!2sin"
              width="500"
              height="400"
              frameborder="0"
              style={{ border: 0 }}
              allowfullscreen=""
              aria-hidden="false"
              tabindex="0"
            ></iframe>
          </div>

          <Visitorform />
        </div>
      </section>
    </>
  );
}

export default Home;
